$(document).ready(function() {

    let return_uuid = $(".item-return_uuid").val()
    $('#table-transfer-v2').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "/get-transfers/"+return_uuid,
        "order": [[ 0, "desc" ]],
        "columns": [
            {data: 'id'},
            {data: 'reference'},
            {data: 'warehouse_code'},
            {data: 'user_text'},
        ],
        "columnDefs": [
            {

                "targets": 4,
                "render": function (data, type, row, meta) {
                    return `<a href="/checar-traspaso/${row.uuid}/${return_uuid}" class="btn-corporativo_detalle">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="11" cy="11" r="8"/>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                        Detalle
                    </a>`;
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    });



    $('#open-modal-import-transfer').click(function() {
        $('#modal-import-transfer').modal('show');
        $('#importTransferForm')[0].reset()
    });

    $("#importTransferForm").on('submit', function(e) {
        e.preventDefault();
        let formData = new FormData(this);
        $.ajax({
            url: "/import-transfer",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.success ) {
                    alertWithBtn(response.msg)
                    $('#modal-import-transfer').modal('hide');
                    $("#table-transfer-v2").DataTable().ajax.reload();
                }else{
                    alertError(response.msg)
                }
            },
            error: function(error) {
                console.error(error);
            }
        })
    })

    $(".form-close-box").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)

        Swal.fire({
            title: '¿Estás seguro?',
            text: "Vas a cerrar la caja",
            icon: 'warning',
            input: 'number',
            inputLabel: 'Peso de la caja (KG)',
            inputPlaceholder: 'Ingresa el peso en kilogramos',
            inputAttributes: {
                min: 0,
                step: 0.01,
                required: true
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, encajar!',
            inputValidator: (value) => {
                if (!value) {
                    return 'Debes ingresar el peso de la caja'
                }
                if (value <= 0) {
                    return 'El peso debe ser mayor a 0'
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                // Agregar el peso al FormData
                data.append('weight', result.value)

                $.ajax({
                    url: "/close-box",
                    method: 'POST',
                    data: data,
                    processData: false,
                    contentType: false,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    beforeSend: function () {

                    },
                    success: function (response) {

                        if (response.success ) {
                            alertWithBtn(response.msg)
                            location.reload()
                        }else{
                            alertError(response.msg)
                        }


                    },
                    error: function (xhr) {
                        const errores = xhr.responseJSON?.errors;
                        if (errores) {
                            alert(Object.values(errores).flat().join('\n'));
                        } else {
                            alert('Ocurrió un error al importar.');
                        }
                    },
                    complete: function () {
                        $('#btn-import-transfer').prop('disabled', false).html('<i class="fas fa-file-import mr-1"></i> Importar');
                    }
                });


            }
        })


    })

});
